import Sidemenu from "../../components/sidemenu";
import { useState, useEffect } from "react";
import * as Styled from './Styled';
import Dropdown from 'react-bootstrap/Dropdown';
import { functionService } from "../../lib/functions";
import InputSuggestion from "../../components/elements/inputSuggestion01";
import { Navigate, useParams } from "react-router-dom";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getFileBase64 } from "../../utils/commonFunctions";
import Select from 'react-select';
import Editor from '../addContest/editor';
import styles from './styles/style.module.css'


const Funnel = ({ mode }) => {

    let { funnelId } = useParams();

    const jobContestData = {
        funnel_type: "",
        funnel_image: "",
        funnel_start_date_time: "",
        funnel_end_date_time: "",
        total_levels: 0,
        contest_recruiter_company: "",
        contest_recruiter_company_name: "",
        job_title: "",
        job_description: "",
        location_type: "",
        min_experience: 0,
        max_experience: 0,
        min_ctc: "",
        max_ctc: "",
        work_payment_type:"",
        ctc_currency: "INR",
        openings: 0,
        job_start_date: "",
        job_location: [],
        job_skills: [],
        job_type: "",
        level_details: [],
        recruiter_specific: true,
        work_payment_type:""

    }

    const coffeeePlusData = {
        funnel_type: '',
        funnel_title: '',
        total_levels: 0,
        level_details: [],
        funnel_skills: [],
        mandatory_skills: [],
        force_skills: [],
        recruiter_specific: false,
        funnel_recruiter_company: "",
        funnel_recruiter_company_name: "",
        funnel_image: "",
        funnel_start_date_time: "",
        funnel_end_date_time: ""
    }

    const coffeeePlusErrors = {
        funnel_title: false,
        funnel_skills: false,
        funnel_image: false,
        level_details: false,
        funnel_start_date_time: false,
        funnel_end_date_time: false,
        funnel_image: false
    }

    const jobContestErrors = {
        recruiter_company_name: false,
        job_title: false,
        location_type: false,
        work_payment_type:false,
        min_experience: false,
        max_experience: false,
        min_ctc: false,
        max_ctc: false,
        openings: false,
        job_start_date: false,
        job_location: false,
        job_skills: false,
        job_description: false,
        job_type: false,
        funnel_image: false,
        level_details: false,
        funnel_start_date_time: false,
        funnel_end_date_time: false,
        contest_image: false
    }

    const currency = ["INR", "EUR", "USD", "BGN", "BAM", "CZK", "JPY", "MOP"];
    const workPaymentType=["Per Hour","Per Month" ,"LPA"]

    const [funnelType, setFunnelType] = useState("");
    const [coffeeePlusState, setCoffeeePlusState] = useState(coffeeePlusData);
    const [jobContestState, setJobContestState] = useState(jobContestData);
    const [company, setCompany] = useState([]);
    const [locations, setLocations] = useState([]);
    const [skills, setSkills] = useState([]);
    const [mandatorySkills, setMandatorySkills] = useState([]);
    const [forceSkills, setForceSkills] = useState([]);
    const [page, setPage] = useState(1);
    const [image, setFunnelImage] = useState("");
    const navigate = useNavigate();
    const [minSkills, setMinSkills] = useState(3);
    const [maxSkills, setMaxSkills] = useState(5);

    // errors state
    const [coffeeePlusStateErrors, setCoffeeePlusStateErrors] = useState(coffeeePlusErrors);
    const [jobContestStateErrors, setJobContestStateErrors] = useState(jobContestErrors);

    // fetch functionality

    const fetchRecruiterCompanies = async () => {
        try {
            let { response } = await functionService.get('coffeeePlus/recruiter-companies')
            if (response.status === 200) {
                setCompany(response?.data?.data?.recruiterCompanies);
            } else {
                console.log("error fetching companies")
            }
        } catch (e) {
            console.log(e);
        }
    }

    const fetchLocations = async (searchParams) => {
        try {
            let urlToRequest = 'coffeeePlus/locations'
            if (searchParams && searchParams !== "" && searchParams !== undefined) {
                urlToRequest += `?location=${searchParams}`
            }
            let { response } = await functionService.get(urlToRequest);
            if (response?.status === 200) {
                setLocations(response?.data?.data?.locations);
            } else {
                console.log("error fetching locations")
            }
        } catch (e) {
            console.log(e);
        }
    }

    const fetchSkills = async (searchParams) => {
        try {
            let urlToRequest = 'coffeeePlus/skills'
            if (searchParams && searchParams !== "" && searchParams !== undefined) {
                urlToRequest += `?skill=${searchParams}`
            }
            let { response } = await functionService.get(urlToRequest);
            if (response.status === 200) {
                setSkills(response?.data?.data?.skills);
                setMandatorySkills(response?.data?.data?.skills);
                setForceSkills(response?.data?.data?.skills);

            } else {
                console.log("error fetching skills")
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        fetchRecruiterCompanies();
        fetchLocations();
        fetchSkills();
        if (mode === "edit") {
            checkAndLoadFunnel();
        }

    }, [])

    // change handlers
    const changeCompany = (c) => {
        if (funnelType === 'CONTEST PLUS') {
            setJobContestState((latestJobContestState) => {
                return {...latestJobContestState, contest_recruiter_company: c.id, contest_recruiter_company_name: c.name};
            });
        } else if (funnelType === 'COFFEEE PLUS') {
            setCoffeeePlusState((latestCofeeePlusState) => {
                return {...latestCofeeePlusState, funnel_recruiter_company: c.id, funnel_recruiter_company_name: c.name};
            });
        }
    }

    const changeJobTitle = (e) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, job_title: e.target.value};
        });
    }

    const changeFunnelType = (e) => {
        setFunnelType(e.target.innerText);
    }

const changeWorkRateType=(e)=>{
    setJobContestState((latestJobContestState)=>{
        return {...latestJobContestState,work_payment_type: e.target.innerText}
    })
}

    const changeJobLocationType = (e) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, location_type: e.target.value};
        });
    }

    const experienceChange = (e, experienceType) => {
        if (experienceType == "MINIMUM") {
            setJobContestState((latestJobContestState) => {
                return {...latestJobContestState, min_experience: e.target.innerText};
            });
        } else if (experienceType == "MAXIMUM") {
            setJobContestState((latestJobContestState) => {
                return {...latestJobContestState, max_experience: e.target.innerText};
            });
        }
    }

    const currencyChange = (e) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, ctc_currency: e.target.innerText};
        });
    }

    const changeCTC = (e, ctcType) => {
        if (ctcType == "MINIMUM") {
            setJobContestState((latestJobContestState) => {
                return {...latestJobContestState, min_ctc: e.target.innerText};
            });
        } else if (ctcType == "MAXIMUM") {
            setJobContestState((latestJobContestState) => {
                return {...latestJobContestState, max_ctc: e.target.innerText};
            });
        }
    }

    const changeJobOpenings = (e) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, openings: e.target.value};
        });
    }

    const changeJobDate = (e) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, job_start_date: e.target.innerText};
        });
    }

    /* const changeJobDescription = (e) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, job_description: e.target.value};
        });
    } */

    const changeJobDescription = (id, value) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, job_description: value};
        });
    }

    const changeJobType = (e) => {
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, job_type: e.target.value};
        });
    }

    const changeFunnelTitle = (e) => {
        setCoffeeePlusState((latestCofeeePlusState) => {
            return {...latestCofeeePlusState, funnel_title: e.target.value}
        })
    }

    const nextPage = () => {
        let flag = saveAndNext();
        if (flag) return;
        setPage(page + 1);
    }

    const prevPage = () => {
        setPage(page - 1);
    }

    const autoCompleteSelect = (name, value) => {
        if (name === "job_location") {
            let locationsArr = jobContestState.job_location;
            if (value && !locationsArr.includes(value)) {
                locationsArr.push(value);
                setJobContestState((latestJobContestState) => {
                    return {...latestJobContestState, job_location: locationsArr};
                });
            }
        } else if (name === "job_skills") {
            let skillsArr = jobContestState.job_skills;
            if (value && !skillsArr.includes(value)) {
                skillsArr.push(value);
                setJobContestState((latestJobContestState) => {
                    return {...latestJobContestState, job_skills: skillsArr};
                });
            }
        } else if (name === "funnel_skills") {
            let skillsArr = coffeeePlusState.funnel_skills;
            if (value && !skillsArr.includes(value)) {
                skillsArr.push(value);
                setCoffeeePlusState((latestCofeeePlusState) => {
                    return {...latestCofeeePlusState, funnel_skills: skillsArr}
                })
            }
        } else if (name == "mandatory_skills") {
            let skillsArr = coffeeePlusState.mandatory_skills;
            if (value && !skillsArr.includes(value)) {
                skillsArr.push(value);
                setCoffeeePlusState((latestCofeeePlusState) => {
                    return {...latestCofeeePlusState, mandatory_skills: skillsArr}
                })
            }

        } else if (name == "force_skills") {
            let skillsArr = coffeeePlusState.force_skills;
            if (value && !skillsArr.includes(value)) {
                skillsArr.push(value);
                setCoffeeePlusState((latestCofeeePlusState) => {
                    return {...latestCofeeePlusState, force_skills: skillsArr}
                })
            }

        } else if(name === 'min_ctc' || name === 'max_ctc') {
            if (value && value !== '') {
                setJobContestState((latestJobContestState) => {
                    return {...latestJobContestState, [name]: value};
                });
            }
        }
    }

    const autoCompleteChange = (name, value) => {
        if (name === "job_location") {
            fetchLocations(value);
        } else if (name === "job_skills" || name === "funnel_skills" || name === "mandatory_skills" || name === "force_skills") {
            fetchSkills(value);
        }
    }

    const onInputChange = (value, name) => {
        // console.log(event.target.value);
        setJobContestState((latestJobContestState) => {
            return {...latestJobContestState, [name]: value};
        });
    }

    const autoCompleteRemove = (name, index) => {
        if (name && typeof index !== 'undefined') {
            if (name === "job_location") {
                let locationsArr = jobContestState.job_location;
                locationsArr.splice(index, 1);
                setJobContestState((latestJobContestState) => {
                    return {...latestJobContestState, job_location: locationsArr};
                });

            } else if (name === "job_skills") {
                let skillsArr = jobContestState.job_skills;
                skillsArr.splice(index, 1);
                setJobContestState((latestJobContestState) => {
                    return {...latestJobContestState, job_skills: skillsArr};
                });

            } else if (name === "funnel_skills") {
                let skillsArr = coffeeePlusState.funnel_skills;
                skillsArr.splice(index, 1);
                setCoffeeePlusState((latestCofeeePlusState) => {
                    return {...latestCofeeePlusState, funnel_skills: skillsArr}
                })

            } else if (name === "mandatory_skills") {
                let skillsArr = coffeeePlusState.mandatory_skills;
                skillsArr.splice(index, 1);
                setCoffeeePlusState((latestCofeeePlusState) => {
                    return {...latestCofeeePlusState, mandatory_skills: skillsArr}
                })

            } else if (name === "force_skills") {
                let skillsArr = coffeeePlusState.force_skills;
                skillsArr.splice(index, 1);
                setCoffeeePlusState((latestCofeeePlusState) => {
                    return {...latestCofeeePlusState, force_skills: skillsArr}
                })
            }
        }
    }

    // level handling

    const levelType = ["ASSESSMENT", "MOCK INTERVIEW", "EXPERT INTERVIEW", "PROJECT ASSESSMENT", "COMPANY ASSESSMENT"];
    const [levels, setLevels] = useState([
        {
            level_type: "",
            data: []
        }
    ]);

    const [activeLevels, setActiveLevels] = useState([0]);
    const difficultyLevels = ['EASY', 'MEDIUM', 'HARD'];
    // level fetch functionality
    const [allTests, setAllTests] = useState([]);
    const [assessments, setAssessments] = useState([]);
    const [mockInterviews, setMockInterviews] = useState([]);
    const [expertInterviews, setExpertInterviews] = useState([]);
    const [projectAssessments, setProjectAssessments] = useState([]);



    const fetchTests = async (searchParams, difficulty, type) => {
        try {
            let owners = "";
            if (funnelType === "CONTEST PLUS") {
                owners = "CONTESTPLUS";
            } else if (funnelType === "COFFEEE PLUS") {
                owners = "COFFEEEPLUS";
            }

            let urlToRequest = 'coffeeePlus/tests'
            if (searchParams && searchParams !== "" && searchParams !== undefined) {
                urlToRequest += `?test=${searchParams}`
            }
            if (difficulty && difficulty !== "" && difficulty !== undefined) {
                urlToRequest += `?difficulty=${difficulty}&type=${type}&owners=${owners}`
            }
            let { response } = await functionService.get(urlToRequest);
            if (response?.status === 200) {
                if (type === "ALL") {
                    setAllTests(response?.data?.data?.tests);
                }
                if (type === "ASSESSMENT" || type === "ALL") {
                    setAssessments(response?.data?.data?.tests);
                }
                if (type === "MOCK INTERVIEW" || type === "ALL") {
                    setMockInterviews(response?.data?.data?.tests);
                }
                if (type === "EXPERT INTERVIEW" || type === "ALL") {
                    setExpertInterviews(response?.data?.data?.tests);
                }
                if (type === "PROJECT ASSESSMENT" || type === "ALL") {
                    setProjectAssessments(response?.data?.data?.tests);
                }
            } else {
                console.log("error fetching tests")
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        fetchTests(null, null, "ALL");
    }, []);

    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");

    const changeLevelType = (e, levelIdx, lt) => {
        const levelToProcess = levels[levelIdx];
        levelToProcess.level_type = lt;
        levelToProcess.data = [];
        if (lt === "ASSESSMENT") {
            levelToProcess.data.push(
                {
                    test_id: "",
                    test_name: "",
                    minimum_passing_marks: 0,
                    total_marks: 0,
                    difficulty: '',
                    mandatory_to_pass: false,
                    record: false
                }
            )
            levelToProcess["passing_criteria"] = "";
            levelToProcess["passing_criteria_number"] = 0;

        } else if (lt === "COMPANY ASSESSMENT") {
            levelToProcess.data.push({
                "title": "",
                "description": ""
            })

        } else {
            levelToProcess.data.push({
                "test_id": "",
                "test_name": "",
                "difficulty": '',
                "record": false
            })
        }
        levelToProcess["locked"] = false;
        levelToProcess["level_title"] = "";
        const updatedLevels = [...levels];
        setLevels(updatedLevels);
    }

    // console.log(levels);

    const changeMinPassMarks = (e, levelIndex, dataIndex) => {
        let dataToChange = levels[levelIndex].data[dataIndex];
        dataToChange.minimum_passing_marks = e.target.value;
        setLevels([...levels]);
    }

    const changeMandatoryToPass = (e, levelIndex, dataIndex) => {
        let dataToChange = levels[levelIndex].data[dataIndex];
        dataToChange.mandatory_to_pass = e.target.checked;
        setLevels([...levels]);
    }

    const changeRecordStatus = (e, levelIndex, dataIndex) => {
        let dataToChange = levels[levelIndex].data[dataIndex];
        dataToChange.record = e.target.checked;
        setLevels([...levels]);
    }

    const changeLockStatus = (e, levelIndex) => {
        let levelToProcess = levels[levelIndex];
        levelToProcess.locked = e.target.checked;
        setLevels([...levels]);
    }

    const changePassingCriteria = (e, criteria, levelIndex) => {
        let levelToProcess = levels[levelIndex];
        if (criteria === "all" || criteria === "specific") {
            levelToProcess["passing_criteria"] = criteria;
        } else if (criteria == null) {
            levelToProcess["passing_criteria_number"] = e.target.value;
        }
        setLevels([...levels]);
    }

    const handleSelectChange = (levelIndex, dataIndex, opt, type) => {
        let levelToProcess = levels[levelIndex];
        levelToProcess.data[dataIndex].test_id = opt.id;
        levelToProcess.data[dataIndex].test_name = opt.label;
        levelToProcess.data[dataIndex].difficulty = opt.difficulty_level;
        if (type === "ASSESSMENT") {
            levelToProcess.data[dataIndex].total_marks = opt.total_marks;
        }
        setLevels([...levels]);
    }

    const getSelectValue = (levelIndex, dataIndex, type) => {
        let tests;
        if (type === "ASSESSMENT") {
            tests = assessments;
        } else if (type === "MOCK INTERVIEW") {
            tests = mockInterviews;
        } else if (type === "EXPERT INTERVIEW") {
            tests = expertInterviews;
        } else if (type === "PROJECT ASSESSMENT") {
            tests = projectAssessments;
        }
        for (let i = 0; i < tests.length; i++) {
            if (tests[i].id === levels[levelIndex].data[dataIndex].test_id) {
                return tests[i];
            }
        }
        // if there is no test of that difficulty then find from parent list
        tests = allTests;
        for (let i = 0; i < tests.length; i++) {
            if (tests[i].id === levels[levelIndex].data[dataIndex].test_id) {
                return tests[i];
            }
        }
        return "";
    }

    const addNewAssessment = (levelIndex, dataIndex) => {
        let levelToProcess = levels[levelIndex];
        levelToProcess.data.push({
            test_id: "",
            test_name: "",
            minimum_passing_marks: 0,
            mandatory_to_pass: false,
            record: false
        })
        setLevels([...levels]);
    }

    const deleteAssessment = (levelIndex, dataIndex) => {
        let levelToProcess = levels[levelIndex];
        if (levelToProcess.data.length <= 1) return;
        let newData = levelToProcess.data.filter ((ele, idx) => {
            return dataIndex !== idx;
        })
        levelToProcess.data = newData;
        setLevels([...levels]);
    }

    const addNewLevel = (e) => {
        levels.push({
            level_type: "",
            data: []
        });
        setLevels([...levels]);
    }

    const deleteLevel = (levelIndex) => {
        if (levels.length === 1) return;
        let newData = levels.filter ((l, lidx) => lidx !== levelIndex)
        setLevels([...newData]);
    }

    const setFunnelDate = (e, type) => {
        if (type === "start") {
            setStartDate(e.target.value);
        } else if (type === "end") {
            setEndDate(e.target.value);
        }
    }

    const setFunnelTime = (e, type) => {
        if (type === "start") {
            setStartTime(e.target.value);
        } else if (type === "end") {
            setEndTime(e.target.value);
        }
    }

    const imageUpload = async (e) => {
        let file = e.target.files[0];
        if (file) {
            const base64 = await getFileBase64(file);
            setFunnelImage(base64);
        } else {
            console.log("Please upload image")
        }
    }

    const handleTestDifficulty = (levelIndex, dataIndex, e, type) => {
        let difficulty = e.target.innerText.trim();
        fetchTests(null, difficulty, type);
    }

    const changeLevelTitle = (levelIndex, e) => {
        let levelToProcess = levels[levelIndex];
        levelToProcess["level_title"] = e.target.value;
        setLevels([...levels]);
    }

    // publish data

    const publish = async (isActive) => {
        let flag = saveAndNext();
        if (flag) return;
        let payload = {};
        if (funnelType === "CONTEST PLUS") {
            payload = {...jobContestState};

        } else if (funnelType === "COFFEEE PLUS") {
            payload = {...coffeeePlusState};
        }
        payload.funnel_type = funnelType;
        payload.funnel_start_date_time = startDate + "T" + startTime + "+0530";
        payload.funnel_end_date_time = endDate + "T" + endTime + "+0530";
        payload.level_details = levels;
        payload.total_levels = levels.length;
        payload.funnel_image = image;
        payload.min_skills = (minSkills == 0 ? 3 : parseInt(minSkills));
        payload.max_skills = (maxSkills == 0 ? 5 : parseInt(maxSkills));
        payload["is_active"] = isActive;

        try {

            let level_details = payload.level_details;
            for (let i = 0; i < level_details.length; i++) {
                level_details[i]["level_number"] = (i + 1);
            }

            if (mode === "new") {
                let { response } = await functionService.post('coffeeePlus/new-funnel', payload);
                if (response.status === 200) {
                    console.log("funnel added");
                } else {
                    console.log("error occured while adding");
                }

            } else if (mode === "edit") {
                let { response } = await functionService.patch(`coffeeePlus/funnel/${funnelId}`, payload);
                if (response.status === 200) {
                    console.log("funnel edited");
                } else {
                    console.log("error occured while updating")
                }
            }
        } catch (e) {
            console.log(e);
        }
        navigate(`${funnelType == "COFFEEE PLUS" ? '/coffeee-plus' : '/contest-plus'}`);
    }

    // recieve data

    const checkAndLoadFunnel = async () => {
        try {
            if (mode === "edit") {
                let { response } = await functionService.get(`coffeeePlus/funnel/${funnelId}`);
                if (response.status === 200) {
                    let funnel = response?.data?.data?.funnel;
                    if (funnel.funnel_type === "COFFEEE PLUS") {
                        funnel.force_skills = (funnel.force_skills == null ? [] : funnel.force_skills)
                        funnel.mandatory_skills = (funnel.mandatory_skills == null ? [] : funnel.mandatory_skills);
                        setCoffeeePlusState({
                            ...funnel
                        });

                    } else if (funnel.funnel_type === "CONTEST PLUS") {
                        setJobContestState({
                            ...funnel,
                            job_start_date: funnel.job_start_date.split("T")[0]
                        });

                    }
                    setFunnelType(funnel.funnel_type);
                    setLevels(funnel.level_details);
                    let [funnel_start_date, funnel_start_time] = funnel.funnel_start_date_time.split("T");
                    let [funnel_end_date, funnel_end_time] = funnel.funnel_end_date_time.split("T");
                    setStartDate(funnel_start_date);
                    setStartTime(moment(moment.utc(funnel.funnel_start_date_time)).utcOffset("+05:30").format("HH:mm"));
                    setEndDate(funnel_end_date);
                    setEndTime(moment(moment.utc(funnel.funnel_end_date_time)).utcOffset("+05:30").format("HH:mm"));
                    setFunnelImage(funnel.funnel_image);
                    setMinSkills(funnel.min_skills);
                    setMaxSkills(funnel.max_skills);

                } else {
                    console.log("Some error in fetching funnel")
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    // validations

    const saveAndNext = () => {
        let flag = false;
        if (funnelType === "") return true;
        if (funnelType === "COFFEEE PLUS") {
            if (minSkills === "" || maxSkills === "" || minSkills < 0 || maxSkills < 0) return true;
            if (maxSkills < minSkills) return true;
        }

        if (page === 1) {
            if (funnelType === "COFFEEE PLUS") {
                if (coffeeePlusState.funnel_title === '') {
                    coffeeePlusErrors.funnel_title = true;
                    flag = true;
                }
                if (coffeeePlusState.funnel_skills.length === 0) {
                    coffeeePlusErrors.funnel_skills = true;
                    flag = true;
                }

                if (image === "") {
                    coffeeePlusErrors.funnel_image = true;
                    flag = true;
                }

                if ((coffeeePlusState.funnel_skills.length + coffeeePlusState.mandatory_skills.length < minSkills) || (coffeeePlusState.funnel_skills.length + coffeeePlusState.mandatory_skills.length < maxSkills)) {
                    flag = true;
                }

                setCoffeeePlusStateErrors((latestCoffeeePlusErrors) => {
                    return {...latestCoffeeePlusErrors, ...coffeeePlusErrors}
                })


            } else if (funnelType === "CONTEST PLUS") {
                if (jobContestState.contest_recruiter_company_name == "") {
                    jobContestErrors.recruiter_company_name = true;
                    flag = true;
                }
                if (jobContestState.job_title === "") {
                    jobContestErrors.job_title = true;
                    flag = true;
                }
                if (jobContestState.location_type === "") {
                    jobContestErrors.location_type = true;
                    flag = true;
                }
                if (jobContestState.min_ctc === "") {
                    jobContestErrors.min_ctc = true;
                    flag = true;
                }
                if (jobContestState.max_ctc === "" || parseInt(jobContestState.max_ctc) > 100 || parseInt(jobContestState.max_ctc) <= parseInt(jobContestState.min_ctc)) {
                    jobContestErrors.max_ctc = true;
                    flag = true;
                }
                if (jobContestState.min_experience === "") {
                    jobContestErrors.min_experience = true;
                    flag = true;
                }
                if (jobContestState.max_experience === "" || parseInt(jobContestState.max_experience) > 100 || parseInt(jobContestState.max_experience) <= parseInt(jobContestState.min_experience)) {
                    jobContestErrors.max_experience = true;
                    flag = true;
                }
                if (jobContestState.job_start_date === "") {
                    jobContestErrors.job_start_date = true;
                    flag = true;
                }
                if (jobContestState.location_type !== "REMOTE"&& jobContestState.job_location.length === 0) {
                    jobContestErrors.job_location = true;
                    flag = true;
                }
                if (jobContestState.job_skills.length === 0) {
                    jobContestErrors.job_skills = true;
                    flag = true;
                }


                if (jobContestState.work_payment_type === "") {
                    jobContestErrors.work_payment_type = true;
                    flag = true;
                }


                if (jobContestState.job_description === "") {
                    jobContestErrors.job_description = true;
                    flag = true;
                }
                if (jobContestState.job_type === "") {
                    jobContestErrors.job_type = true;
                    flag = true;
                }
                // if (image === "") {
                //     jobContestErrors.contest_image = true;
                //     flag = true;
                // }
                // if (jobContestData.job_skills.length < minSkills || jobContestData.job_skills.length < maxSkills) {
                //     flag = true;
                // }

                setJobContestStateErrors((latestJobContestErrors) => {
                    return {...latestJobContestErrors, ...jobContestErrors}
                })
            }
        } else if (page === 2) {
            if (funnelType === "COFFEEE PLUS") {
                if (levels.length === 0) {
                    flag = true;
                    setCoffeeePlusStateErrors((latestCoffeeePlusErrors) => {
                        return {...latestCoffeeePlusErrors, level_details: true}
                    })
                }
            } else if (funnelType === "CONTEST PLUS") {
                if (levels.length === 0) {
                    flag = true;
                    setJobContestStateErrors((latestJobContestErrors) => {
                        return {...latestJobContestErrors, level_details: true}
                    })
                }
            }

        } else if (page === 3) {
            if (funnelType === "COFFEEE PLUS") {
                if (startDate === "" || startTime === "") {
                    flag = true;
                    coffeeePlusErrors.funnel_start_date_time = true;
                }

                if (endDate === "" || endTime === "") {
                    flag = true;
                    coffeeePlusErrors.funnel_end_date_time = true;
                }

                setCoffeeePlusStateErrors((latestCoffeeePlusErrors) => {
                    return {...latestCoffeeePlusErrors, ...coffeeePlusErrors}
                })

            } else if (funnelType === "CONTEST PLUS") {
                if (startDate === "" || startTime === "") {
                    flag = true;
                    jobContestErrors.funnel_start_date_time = true;
                }

                if (endDate === "" || endTime === "") {
                    flag = true;
                    jobContestErrors.funnel_end_date_time = true;
                }

                setJobContestStateErrors((latestJobContestErrors) => {
                    return {...latestJobContestErrors, ...jobContestErrors}
                })
            }
        }
        return flag;
    }

    // console.log("levels", levels)


    const handleActiveLevel = (levelIndex) => {
        if (activeLevels.includes(levelIndex)) {
            setActiveLevels(activeLevels.filter(function (l) {
                return l !== levelIndex;
            }))
        } else {
            activeLevels.push(levelIndex);
            setActiveLevels([...activeLevels]);
        }
    }

    const handleJourneySkills = (e, type) => {
        let value = e.target.value;
        if (type === "MIN") {
            setMinSkills(value);
        } else if (type === "MAX") {
            setMaxSkills(value);
        }
    }

    const handleCompanyRoundTitle = (levelIndex, dataIndex, e) => {
        let levelToProcess = levels[levelIndex];
        levelToProcess.data[dataIndex].title = e.target.value;
        setLevels([...levels]);
    }

    const handleCompanyRoundDesc = (levelIndex, dataIndex, e) => {
        let levelToProcess = levels[levelIndex];
        levelToProcess.data[dataIndex].description = e.target.value;
        setLevels([...levels]);
    }

    // console.log(levels)

    return (
        <Styled.MainDiv>
        <Sidemenu />
        <Styled.ColumnDiv style={{backgroundColor: "#E5E5E5"}}>
        <h1 className={styles.heading}>{funnelType === "COFFEEE PLUS" ? "New Coffeee+ Assessment" : "New Contest"}</h1>
            <div className={styles.progressBar}>
                <div className={ page === 1 ? styles.activeBar :
                    ((page === 2 || page === 3) ? styles.stepDone : styles.activeBar) }>
                        Details</div>

                <div className={page === 1 ? '' : (page === 2 ? styles.activeBar : styles.stepDone)}>
                        Levels</div>

                <div className={(page === 1 || page === 2 ? '' : styles.activeBar)}>
                        Setting & Publish</div>
            </div>
            {
                page == 1 ?
                <div className={styles.pageWrap}>
                    <p className={styles.subHeading}>Enter details</p>
                    <div style={{overflow: "scroll", padding: "0 0 10px"}}>
                        <p className={styles.labelName}>Select Type</p>
                        <Dropdown className={styles.dropdownParent} style={{margin: "2px 0 40px", width: "600px"}}>
                            <Dropdown.Toggle className={styles.dropdown} variant="success" id="dropdown-basic">
                                {
                                    funnelType !== "" ? funnelType : "Select Type*"
                                }
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={styles.dropdownMenu}>
                                <Dropdown.Item onClick={(e) => changeFunnelType(e)}>CONTEST PLUS</Dropdown.Item>
                                <Dropdown.Item onClick={(e) => changeFunnelType(e)}>COFFEEE PLUS</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        {
                            funnelType == 'CONTEST PLUS' ?
                            <div>
                                <p className={`${styles.labelName} ${jobContestStateErrors.recruiter_company_name ? styles.errorDropDownLabel : ''}`}>Company Name*</p>
                                <Dropdown className={styles.dropdownParent} style={{margin: "2px 0 40px", width: "600px"}}>
                                    <Dropdown.Toggle className={styles.dropdown} variant="success" id="dropdown-basic">
                                        {
                                            jobContestState.contest_recruiter_company_name !== "" ? jobContestState.contest_recruiter_company_name : "Select*"
                                        }
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className={styles.dropdownMenu} style={{height: "200px", overflow: "scroll"}}>
                                        {
                                            company?.map ((c) => (
                                                <Dropdown.Item key={c.id} onClick={() => changeCompany(c)}>{c.name}</Dropdown.Item>
                                            ))
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>

                                <p className={`${styles.labelName} ${jobContestStateErrors.job_title ? styles.errorLabel : ''}`}>Job Title*</p>
                                <label style={{width:"600px"}}>
                                    <input className={styles.input} type="text" value={jobContestState.job_title} onChange={(e) => changeJobTitle(e)}/>
                                </label>

                                <div className={styles.locationTypeWrap}>
                                    <p className={`${styles.labelName} ${jobContestStateErrors.location_type ? styles.errorLabel : ''}`}>Location Type*</p>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <p>
                                            <input checked={jobContestState.location_type === "ONSITE"} type="radio" value="ONSITE" id="ONSITE" name="location_type" onChange={(e) => changeJobLocationType(e)} />
                                            <label htmlFor="ONSITE">OnSite</label>
                                        </p>
                                        <p>
                                            <input checked={jobContestState.location_type === "REMOTE"} type="radio" value="REMOTE" id="REMOTE" name="location_type" onChange={(e) => changeJobLocationType(e)} />
                                            <label htmlFor="REMOTE">Remote</label>
                                        </p>
                                        <p>
                                            <input checked={jobContestState.location_type === "HYBRID"} type="radio" value="HYBRID" id="HYBRID" name="location_type" onChange={(e) => changeJobLocationType(e)} />
                                            <label htmlFor="HYBRID">Hybrid</label>
                                        </p>
                                    </div>
                                </div>

                                <p className={`${styles.labelName} ${jobContestStateErrors.min_experience || jobContestStateErrors.max_experience ? styles.errorLabel : ''}`}>Experience Range* Years</p>
                                <div style={{display: "flex", alignItems: "center"}}>
                                <div>
                                    <label style={{width:"295px", marginRight: '10px'}}>
                                        <input className={styles.input} type="text" value={parseInt(jobContestState.min_experience) > 0 ? jobContestState.min_experience : ""} onChange={(e)=>onInputChange(e.target.value, 'min_experience')} placeholder="Minimum Years"/>
                                    </label>
                                </div>

                                <div>
                                    <label style={{width:"295px"}}>
                                        <input className={styles.input} type="text" value={parseInt(jobContestState.max_experience) > 0 && parseInt(jobContestState.max_experience) <= 25 ? jobContestState.max_experience : ""} onChange={(e)=>onInputChange(e.target.value, 'max_experience')} placeholder="Maximum Years"/>
                                    </label>
                                </div>

                                </div>

                                <p className={`${styles.labelName} ${jobContestStateErrors.min_ctc || jobContestStateErrors.max_ctc ? styles.errorLabel : ''}`}>CTC Range</p>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <Dropdown className={styles.dropdownParent} style={{marginRight: "16px", width:"104px"}}>
                                        <Dropdown.Toggle className={styles.dropdown} variant="success" id="dropdown-basic">
                                            {
                                                jobContestState.ctc_currency !== "" ? jobContestState.ctc_currency : "INR"
                                            }
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{height: "200px", overflow: "scroll", width:"104px"}}>
                                            {
                                                currency.map ((curr) => (
                                                    <Dropdown.Item onClick={(e) => currencyChange(e)}>{curr}</Dropdown.Item>
                                                ))
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    <div>
                                        <label style={{width:"235px", marginRight: '10px'}}>
                                            <input className={styles.input} type="text" value={parseInt(jobContestState.min_ctc) > 0 ? jobContestState.min_ctc : ""} onChange={(e)=>onInputChange(e.target.value, 'min_ctc')} placeholder="Minimum "/>
                                        </label>
                                    </div>

                                    <div>
                                        <label style={{width:"235px"}}>
                                            <input className={styles.input} type="text" value={parseInt(jobContestState.max_ctc) > 0 && parseInt(jobContestState.max_ctc) <= 100 ? jobContestState.max_ctc : ""} onChange={(e)=>onInputChange(e.target.value, 'max_ctc')} placeholder="Maximum "/>
                                        </label>
                                    </div>

                                    <Dropdown className={styles.dropdownParent} style={{marginLeft: "16px", width:"108px"}}>
                                        <Dropdown.Toggle className={styles.dropdown} variant="success" id="dropdown-basic">
                                            {
                                                jobContestState.work_payment_type !== "" ? jobContestState.work_payment_type: "Select"
                                            }
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{ overflow: "scroll", width:"100px"}}>
                                            {
                                                workPaymentType.map ((type) => (
                                                    <Dropdown.Item onClick={(e) =>changeWorkRateType(e) }>{type}</Dropdown.Item>
                                                ))
                                            }
                                        </Dropdown.Menu>

                                    </Dropdown>
                                    <p className={`${styles.labelName} ${jobContestStateErrors.work_payment_type ? styles.errorLabel : ''}`} style={{marginLeft:'-100px',marginTop:'-80px'}}>{jobContestStateErrors.work_payment_type ?'please select one value':''}</p>
                                    </div>


                                <p className={`${styles.labelName} ${jobContestStateErrors.openings ? styles.errorLabel : ''}`}>Number of Openings</p>
                                <div>
                                    <label style={{width:"600px"}}>
                                        <input className={styles.input} type="text" value={jobContestState.openings > 0 ? jobContestState.openings : ""} onChange={(e) => changeJobOpenings(e)} placeholder="e.g 1,2 etc"/>
                                    </label>
                                </div>

                                <p className={`${styles.labelName} ${jobContestStateErrors.job_start_date ? styles.errorLabel : ''}`}>Job Start Date</p>
                                {/* <div>
                                    <label style={{width:"600px"}}>
                                        <input className={styles.input} type="date" value={jobContestState.job_start_date} onChange={(e) => changeJobDate(e)} />
                                    </label>
                                </div> */}

                        <Dropdown className={styles.dropdownParent} style={{margin: "2px 0 40px", width: "600px"}}>
                            <Dropdown.Toggle className={styles.dropdown} variant="success" id="dropdown-basic">
                            {
                                                jobContestState.job_start_date !== "" ? jobContestState.job_start_date: "Select"
                                            }
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={styles.dropdownMenu}>
                                <Dropdown.Item onClick={(e) => changeJobDate(e)}>Immediate</Dropdown.Item>
                                <Dropdown.Item onClick={(e) => changeJobDate(e)}>Within 1 week</Dropdown.Item>
                                <Dropdown.Item onClick={(e) => changeJobDate(e)}>Within 2 week</Dropdown.Item>
                                <Dropdown.Item onClick={(e) => changeJobDate(e)}>Within 1 month</Dropdown.Item>
                                <Dropdown.Item onClick={(e) => changeJobDate(e)}>After 1 month</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>



                                {jobContestState.location_type !== "REMOTE"&&
                                <>
                                <p className={`${styles.labelName} ${jobContestStateErrors.job_location ? styles.errorLabel : ''}`}>Job Location*</p>
                                 <div className={styles.multipleSelectInput}>
                                 <InputSuggestion placeholder="e.g Delhi NCR, Chennai etc" list={locations || []} value="id" name="job_location" selected={autoCompleteSelect} change={autoCompleteChange} remove={autoCompleteRemove} width="600px" height="48px" option="city_name" active={jobContestState.job_location} info="You can choose multiple locations" />
                             </div></>}


                                <p className={`${styles.labelName} ${jobContestStateErrors.job_skills ? styles.errorLabel : ''}`}>Skills*</p>
                                <div className={styles.multipleSelectInput}>
                                    <InputSuggestion placeholder="Search Skills" list={skills || []} value="id" name="job_skills" selected={autoCompleteSelect} change={autoCompleteChange} remove={autoCompleteRemove} width="600px" height="48px" option="name" active={jobContestState.job_skills} info="You can choose multiple skills" />
                                </div>

                                <p className={`${styles.labelName} ${jobContestStateErrors.job_description ? styles.errorLabel : ''}`}>Job Description</p>
                                <div>
                                    <Editor height="200px" width="600px" id="jd" placeholder="write description here" value={jobContestState.job_description} change={changeJobDescription} />
                                    {/* <textarea style={{width:"600px", height:"128px", border:"1px solid #c9c9c9"}} value={jobContestState.job_description} name="job_description" id="jd" cols="30" rows="5" placeholder="write description here" onChange={(e) => changeJobDescription(e)}></textarea> */}
                                </div>

                                <p className={`${styles.labelName} ${jobContestStateErrors.job_type ? styles.errorLabel : ''}`}>Job Type</p>
                                <div className={styles.jobTypeWrap}>
                                    <p>
                                        <label>
                                            <input checked={jobContestState.job_type === "CONTRACT"} type="radio" value="CONTRACT" name="job_type" onChange={(e) => changeJobType(e)} />
                                            Contract
                                        </label>
                                    </p>
                                    <p>
                                        <label>
                                            <input checked={jobContestState.job_type === "INTERNSHIP"} type="radio" value="INTERNSHIP" name="job_type" onChange={(e) => changeJobType(e)} />
                                            Internship
                                        </label>
                                    </p>
                                    <p>
                                        <label>
                                            <input checked={jobContestState.job_type === "FULLTIME"} type="radio" value="FULLTIME" name="job_type" onChange={(e) => changeJobType(e)} />
                                            FullTime
                                        </label>
                                    </p>
                                    <p>
                                        <label>
                                            <input checked={jobContestState.job_type === "PART TIME"} type="radio" value="PART TIME" name="job_type" onChange={(e) => changeJobType(e)} />
                                            Part Time
                                        </label>
                                    </p>
                                    <p>
                                        <label>
                                            <input checked={jobContestState.job_type === "FREELANCE"} type="radio" value="FREELANCE" name="job_type" onChange={(e) => changeJobType(e)} />
                                            Freelance
                                        </label>
                                    </p>
                                </div>

                            </div>
                            : funnelType == 'COFFEEE PLUS' ?
                            <div>
                                <p className={`${styles.labelName} ${coffeeePlusStateErrors.funnel_title ? styles.errorLabel : ''}`}>Title</p>
                                <div>
                                    <label style={{width: "100%"}}>
                                        <input className={styles.input} type="text" onChange={(e) => changeFunnelTitle(e)} value={coffeeePlusState.funnel_title} placeholder="Enter Title Here"/>
                                    </label>
                                </div>

                                <p className={`${coffeeePlusStateErrors.funnel_skills ? styles.errorLabel : ''}`}>Skill</p>
                                <div className={styles.multipleSelectInput}>
                                    <InputSuggestion placeholder="Search Skills" list={skills || []} value="id" name="funnel_skills" selected={autoCompleteSelect} change={autoCompleteChange} remove={autoCompleteRemove} width="616px" height="48px" option="name" active={coffeeePlusState.funnel_skills} info="You can choose multiple skills" style={{border:"1px solid #ECECEC"}} />
                                </div>

                                <p>Mandatory Skills</p>
                                <div className={styles.multipleSelectInput}>
                                    <InputSuggestion placeholder="Search Skills" list={mandatorySkills || []} value="id" name="mandatory_skills" selected={autoCompleteSelect} change={autoCompleteChange} remove={autoCompleteRemove} width="616px" height="48px" option="name" active={coffeeePlusState.mandatory_skills} info="You can choose multiple skills" style={{border:"1px solid #ECECEC"}} />
                                </div>

                                <p>Force Skills (This automatically forces the candidate to have assessment of these skills)</p>
                                <div className={styles.multipleSelectInput}>
                                    <InputSuggestion placeholder="Search Skills" list={forceSkills || []} value="id" name="force_skills" selected={autoCompleteSelect} change={autoCompleteChange} remove={autoCompleteRemove} width="616px" height="48px" option="name" active={coffeeePlusState.force_skills} info="You can choose multiple skills" style={{border:"1px solid #ECECEC"}} />
                                </div>

                                <p className={`${styles.labelName} ${minSkills == 0 || minSkills == "" ? styles.errorLabel : ''}`}>Min Number of Skills required</p>
                                <input className={styles.input} type="text" placeholder="Enter Minimum Number of Skills" value={minSkills} onChange={(e) => handleJourneySkills(e, "MIN")}/>

                                <p className={`${styles.labelName} ${maxSkills == 0 || maxSkills == "" ? styles.errorLabel : ''}`}>Max Number of Skills required</p>
                                <input className={styles.input} type="text" placeholder="Enter Maximum Number of Skills" value={maxSkills} onChange={(e) => handleJourneySkills(e, "MAX")}/>

                                {
                                    funnelType === "COFFEEE PLUS" ?
                                        (coffeeePlusState.funnel_skills.length + coffeeePlusState.mandatory_skills.length < minSkills) || (coffeeePlusState.funnel_skills.length + coffeeePlusState.mandatory_skills.length < maxSkills) || (minSkills > maxSkills) ?
                                            <p style={{margin:"4px 0 0", color:"red", fontSize:"12px", lineHeight:"14px"}}>Set Skills required for this journey along with min & max number accordingly</p>
                                            : ''
                                    : ''
                                }

                            </div>
                            : ""

                        }

                        <div>
                            <p className={"jj"}>Add Image</p>
                            <div className={styles.imageWrap}>
                                <p>Image formats (PNG, JPEG or JPG)</p>
                                {
                                    image !== "" ?
                                    <img src={image} alt="funnel_image" style={{margin: "10px auto", display: "block", width: "100px", height: "100px"}}/>
                                    : ""
                                }
                                <label>
                                    Upload Cover Image
                                    <input type="file" onChange={(e) => imageUpload(e)}/>
                                </label>
                            </div>
                        </div>

                        <div className={styles.saveAndNextBtnWrap}>
                            <button onClick={() => nextPage()} className={styles.saveBtn}>Save & Next</button>
                            <button onClick={() => navigate(`${funnelType == 'COFFEEE PLUS' ? '/coffeee-plus' : '/contest-plus'}`)} className={styles.cancelBtn}>Cancel</button>
                        </div>

                    </div>
                </div>
                : page == 2 ?
                <div className={styles.pageWrap}>
                    <h1 style={{fontSize:"20px", lineHeight:"18px", fontWeight:"600", margin:"50px 0 25px 0"}}>Levels</h1>
                    {
                        levels?.map((l, lidx) => (
                            <div className={styles.levelWrap}>
                                <p className={styles.levelHeading} onClick={(e) => handleActiveLevel(lidx)}>Level {lidx + 1}</p>
                                <div className={styles.addDeleteBtnWrap}>
                                    <button onClick={(e) => deleteLevel(lidx)}></button>
                                    <button onClick={(e) => addNewLevel(e)}></button>
                                </div>
                                {
                                    activeLevels.includes(lidx) ?
                                        <div className={styles.levelContent} style={{marginBottom:"30px"}}>
                                        <p className={styles.labelName}>Level Type</p>
                                        <Dropdown className={styles.dropdownParent} style={{margin: "2px 0 40px"}}>
                                            <Dropdown.Toggle className={styles.dropdown} variant="success" id="dropdown-basic">
                                                {
                                                    l.level_type !== "" ? l.level_type : "Select Type"
                                                }
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className={styles.dropdownMenu}>
                                                {
                                                    levelType?.map ((lt) => (
                                                        <Dropdown.Item onClick={(e) => changeLevelType(e, lidx, lt)} >{lt}</Dropdown.Item>
                                                    ))
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <p className={styles.labelName}>Level Title</p>
                                        <input className={styles.input} type="text" placeholder="Enter Level Title" value={levels[lidx].level_title} onChange={(e) => changeLevelTitle(lidx, e)}/>

                                        {
                                            l.level_type === "ASSESSMENT" ?
                                            <>
                                                {
                                                    l.data?.map ((d, didx) => (
                                                    <div className={styles.assessmentWrap}>
                                                            <div>
                                                                <p className={styles.labelName}>Select Assessment</p>
                                                                <div className={styles.addDeleteBtnWrap}>
                                                                    <button type="delete" onClick={() => deleteAssessment(lidx, didx)}></button>
                                                                    <button type="add" onClick={() => addNewAssessment(lidx, didx)}></button>
                                                                </div>
                                                            </div>

                                                            <div className={styles.parentSelect}>
                                                                <Select
                                                                        options={assessments}
                                                                        onChange={(opt) => handleSelectChange(lidx, didx, opt, "ASSESSMENT")}
                                                                        className={styles.customSelect}
                                                                        value={getSelectValue(lidx, didx, "ASSESSMENT")}
                                                                />
                                                                <div className={styles.difficultybtnwrap}>
                                                                    {
                                                                        difficultyLevels.map((d) => (
                                                                            <button className={styles.difficultybtn} onClick={(e) => handleTestDifficulty(lidx, didx, e, "ASSESSMENT")}>{d}</button>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                            {
                                                                levels[lidx].data[didx].difficulty !== "" ?
                                                                <p style={{margin:"0", fontWeight:"600", fontSize:"16px", lineHeight:"18px", margin:"-18px 0 18px"}}>Difficulty of selected test is: {levels[lidx].data[didx].difficulty}</p>
                                                                : ''
                                                            }

                                                            <div className={styles.assessmentLabelWrap}>
                                                                <label style={{marginBottom: "12px", display:"flex", flexDirection:"column", alignItems:"flex-start"}} className={styles.labelName} >
                                                                        Minimum Passing Marks
                                                                        <input style={{marginTop:"12px"}} className={styles.input} value={d.minimum_passing_marks} onChange={(e) => changeMinPassMarks(e, lidx, didx)} type="text"  placeholder="Enter marks" />
                                                                    </label>
                                                                <p style={{margin: "0px", marginTop:"10px", backgroundColor:"transparent", padding:"5px", maxWidth:"fit-content", borderRadius:"8px"}}>Total Marks: {levels[lidx].data[didx].total_marks}</p>
                                                                <p style={{display: "flex", alignItems: "center", marginTop: "16px", marginBottom:"16px"}}>
                                                                    <label className={styles.labelName} >
                                                                        <input style={{marginRight: "11px"}} checked={d.mandatory_to_pass} type="checkbox" onChange={(e) => changeMandatoryToPass(e, lidx, didx)} />
                                                                        Mandatory to pass this assessment
                                                                    </label>
                                                                </p>
                                                                <p style={{display: "flex", alignItems: "center", marginTop: "0px"}}>
                                                                    <label className={styles.labelName} >
                                                                        <input style={{marginRight: "11px"}} checked={d.record} type="checkbox" onChange={(e) => changeRecordStatus(e, lidx, didx)} />
                                                                        Record this assessment
                                                                    </label>
                                                                </p>
                                                            </div>
                                                    </div>
                                                    ))
                                                }
                                                <p className={styles.labelName}>Assessment passing criteria</p>
                                                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", maxWidth: "470px", width:"100%"}}>
                                                    <label className={styles.labelName} >
                                                        <input checked={l.passing_criteria == "all"} type="radio" onChange={(e) => {changePassingCriteria(e, "all", lidx)}} />
                                                        All assessments
                                                    </label>
                                                    <label className={styles.labelName} >
                                                        <input checked={l.passing_criteria == "specific"} type="radio" onChange={(e) => {changePassingCriteria(e, "specific", lidx)}} />
                                                        Specific number of assessments
                                                    </label>
                                                </div>
                                                {
                                                    l.passing_criteria == "specific" ?
                                                    <label style={{marginTop: "16px"}} className={styles.labelName} >
                                                        <input className={styles.input} value={l.passing_criteria_number} onChange={(e) => {changePassingCriteria(e, null, lidx)}} type="text" placeholder="Enter minimum number of assessments to be passed to move forward" />
                                                    </label>
                                                    : ''
                                                }
                                                <div className={styles.lockWrap}>
                                                    <label>
                                                    <input type="checkbox" checked={levels[lidx].locked} onChange={(e) => changeLockStatus(e, lidx)}/>
                                                        Lock This Level
                                                    </label>
                                                </div>
                                            </>

                                            : l.level_type === "EXPERT INTERVIEW" ?
                                            <>
                                                {
                                                    l.data?.map ((d, didx) => (
                                                        <div className={styles.assessmentWrap}>
                                                            <p>Select Expert Interview</p>
                                                            <div className={styles.addDeleteBtnWrap}>
                                                                <button type="delete" onClick={() => deleteAssessment(lidx, didx)}></button>
                                                                <button type="add" onClick={() => addNewAssessment(lidx, didx)}></button>
                                                            </div>
                                                            <div className={styles.parentSelect}>
                                                                <Select
                                                                        options={expertInterviews}
                                                                        onChange={(opt) => handleSelectChange(lidx, didx, opt, "EXPERT INTERVIEW")}
                                                                        className={styles.customSelect}
                                                                        value={getSelectValue(lidx, didx, "EXPERT INTERVIEW")}
                                                                />
                                                                <div className={styles.difficultybtnwrap}>
                                                                    {
                                                                        difficultyLevels.map((d) => (
                                                                            <button className={styles.difficultybtn} onClick={(e) => handleTestDifficulty(lidx, didx, e, "EXPERT INTERVIEW")}>{d}</button>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                            {
                                                                levels[lidx].data[didx].difficulty !== "" ?
                                                                <p style={{margin:"0", fontWeight:"600", fontSize:"16px", lineHeight:"18px", margin:"-18px 0 18px"}}>Difficulty of selected test is: {levels[lidx].data[didx].difficulty}</p>
                                                                : ''
                                                            }

                                                            <div className={styles.recordWrap}>
                                                                <label>
                                                                    <input type="checkbox" checked={d.record} onChange={(e) => changeRecordStatus(e, lidx, didx)}/>
                                                                    Record this Interview
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                <div className={styles.lockWrap}>
                                                    <label>
                                                        <input type="checkbox" checked={levels[lidx].locked} onChange={(e) => changeLockStatus(e, lidx)}/>
                                                        Lock This Level
                                                    </label>
                                                </div>
                                            </>


                                            : l.level_type === "MOCK INTERVIEW" ?
                                            <>
                                                {
                                                    l.data?.map ((d, didx) => (
                                                        <div className={styles.assessmentWrap}>
                                                            <p>Select Mock Interview</p>
                                                            <div className={styles.addDeleteBtnWrap}>
                                                                <button type="delete" onClick={() => deleteAssessment(lidx, didx)}></button>
                                                                <button type="add" onClick={() => addNewAssessment(lidx, didx)}></button>
                                                            </div>
                                                            <div className={styles.parentSelect}>
                                                                <Select
                                                                        options={mockInterviews}
                                                                        onChange={(opt) => handleSelectChange(lidx, didx, opt, "MOCK INTERVIEW")}
                                                                        className={styles.customSelect}
                                                                        value={getSelectValue(lidx, didx, "MOCK INTERVIEW")}
                                                                />
                                                                <div className={styles.difficultybtnwrap}>
                                                                    {
                                                                        difficultyLevels.map((d) => (
                                                                            <button className={styles.difficultybtn} onClick={(e) => handleTestDifficulty(lidx, didx, e, "MOCK INTERVIEW")}>{d}</button>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                            {
                                                                levels[lidx].data[didx].difficulty !== "" ?
                                                                <p style={{margin:"0", fontWeight:"600", fontSize:"16px", lineHeight:"18px", margin:"-18px 0 18px"}}>Difficulty of selected test is: {levels[lidx].data[didx].difficulty}</p>
                                                                : ''
                                                            }

                                                            <div className={styles.recordWrap}>
                                                                <label>
                                                                    <input type="checkbox" checked={d.record} onChange={(e) => changeRecordStatus(e, lidx, didx)}/>
                                                                    Record this Interview
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                <div className={styles.lockWrap}>
                                                    <label>
                                                        <input type="checkbox" checked={levels[lidx].locked} onChange={(e) => changeLockStatus(e, lidx)}/>
                                                        Lock This Level
                                                    </label>
                                                </div>
                                            </>


                                            : l.level_type === "PROJECT ASSESSMENT" ?
                                            <>
                                                {
                                                    l.data?.map ((d, didx) => (
                                                        <div className={styles.assessmentWrap}>
                                                            <p>Select Project Assessment</p>
                                                            <div className={styles.addDeleteBtnWrap}>
                                                                <button type="delete" onClick={() => deleteAssessment(lidx, didx)}></button>
                                                                <button type="add" onClick={() => addNewAssessment(lidx, didx)}></button>
                                                            </div>
                                                            <div className={styles.parentSelect}>
                                                                <Select
                                                                        options={projectAssessments}
                                                                        onChange={(opt) => handleSelectChange(lidx, didx, opt, "PROJECT ASSESSMENT")}
                                                                        className={styles.customSelect}
                                                                        value={getSelectValue(lidx, didx, "PROJECT ASSESSMENT")}
                                                                />
                                                                <div className={styles.difficultybtnwrap}>
                                                                    {
                                                                        difficultyLevels.map((d) => (
                                                                            <button className={styles.difficultybtn} onClick={(e) => handleTestDifficulty(lidx, didx, e, "PROJECT ASSESSMENT")}>{d}</button>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                            {
                                                                levels[lidx].data[didx].difficulty !== "" ?
                                                                <p style={{margin:"0", fontWeight:"600", fontSize:"16px", lineHeight:"18px", margin:"-18px 0 18px"}}>Difficulty of selected test is: {levels[lidx].data[didx].difficulty}</p>
                                                                : ''
                                                            }

                                                            <div className={styles.recordWrap}>
                                                                <label>
                                                                    <input type="checkbox" checked={d.record} onChange={(e) => changeRecordStatus(e, lidx, didx)}/>
                                                                    Record this Assessment
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                <div className={styles.lockWrap}>
                                                    <label>
                                                        <input type="checkbox" checked={levels[lidx].locked} onChange={(e) => changeLockStatus(e, lidx)}/>
                                                        Lock This Level
                                                    </label>
                                                </div>
                                            </>

                                            : l.level_type === "COMPANY ASSESSMENT" ?
                                            <>
                                                {
                                                    l.data?.map ((d, didx) => (
                                                        <div>
                                                            <label style={{margin: "30px 0", display:"flex", flexDirection:"column", alignItems:"flex-start"}} className={styles.labelName}>
                                                                Title
                                                                <input style={{marginTop:"12px"}} className={styles.input} type="text" value={d.title} onChange={(e) => handleCompanyRoundTitle(lidx, didx, e)}/>
                                                            </label>
                                                            <label style={{marginBottom: "12px", display:"flex", flexDirection:"column", alignItems:"flex-start"}} className={styles.labelName}>
                                                                Description
                                                                <input style={{marginTop:"12px"}} className={styles.input} type="text" value={d.description} onChange={(e) => handleCompanyRoundDesc(lidx, didx, e)}/>
                                                            </label>
                                                        </div>
                                                    ))
                                                }
                                            </>

                                            : ''
                                        }
                                        </div>
                                    : ''
                                }
                            </div>
                        ))
                    }

                    <div className={styles.saveAndNextBtnWrap}>
                        <button className={styles.saveBtn} onClick={() => nextPage()}>Save & Next</button>
                        <button className={styles.cancelBtn} onClick={() => prevPage()}>Go Back</button>
                    </div>

                </div>
                : page == 3 ?
                <div className={styles.pageWrap}>
                    <div className={styles.dateTimeWrap}>
                        <label>
                            Start Date
                            <input className={styles.input} value={startDate} type="date" onChange={(e) => setFunnelDate(e, "start")} />
                        </label>
                        <label>
                            Start Time
                            <input className={styles.input} value={startTime} type="time" onChange={(e) => setFunnelTime(e, "start")} />
                        </label>
                    </div>

                    {
                        funnelType === "COFFEEE PLUS" ?
                        coffeeePlusStateErrors.funnel_start_date_time && (startDate == "" ||  startTime == "") ?
                                <p style={{margin:"4px 0 0", color:"red", fontSize:"12px", lineHeight:"14px"}}>Start Date & Time, both are required</p>
                                : ''
                        :
                        funnelType === "CONTEST PLUS" ?
                        jobContestStateErrors.funnel_start_date_time && (startDate == "" ||  startTime == "") ?
                                <p style={{margin:"4px 0 0", color:"red", fontSize:"12px", lineHeight:"14px"}}>Start Date & Time, both are required</p>
                                : ''
                        : ''
                    }

                    <div className={styles.dateTimeWrap}>
                        <label>
                            End Date
                            <input className={styles.input} value={endDate} type="date" onChange={(e) => setFunnelDate(e, "end")} />
                        </label>
                        <label>
                            End Time
                            <input className={styles.input} value={endTime} type="time" onChange={(e) => setFunnelTime(e, "end")} />
                        </label>
                    </div>

                    {
                        funnelType === "COFFEEE PLUS" ?
                        coffeeePlusStateErrors.funnel_end_date_time && (endDate == "" ||  endTime == "") ?
                                <p style={{margin:"4px 0 0", color:"red", fontSize:"12px", lineHeight:"14px"}}>End Date & Time, both are required</p>
                                : ''
                        :
                        funnelType === "CONTEST PLUS" ?
                        jobContestStateErrors.funnel_end_date_time && (endDate == "" ||  endTime == "") ?
                                <p style={{margin:"4px 0 0", color:"red", fontSize:"12px", lineHeight:"14px"}}>End Date & Time, both are required</p>
                                : ''
                        : ''
                    }

                    <div className={styles.saveAndNextBtnWrap}>
                        <button className={styles.saveBtn} onClick={() => publish(true)}>Publish</button>
                        {
                            funnelType == "CONTEST PLUS" ?
                            <button className={styles.saveBtn} onClick={() => publish(false)}>Draft</button>
                            : ''
                        }
                        <button className={styles.cancelBtn} onClick={() => prevPage()}>Go Back</button>
                    </div>
                </div> : ''
            }
        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
}

export default Funnel;